import { render, staticRenderFns } from "./Staffs.vue?vue&type=template&id=7e71807b&scoped=true&"
import script from "./Staffs.vue?vue&type=script&lang=js&"
export * from "./Staffs.vue?vue&type=script&lang=js&"
import style0 from "./Staffs.vue?vue&type=style&index=0&id=7e71807b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e71807b",
  null
  
)

export default component.exports